<template>
    <div id="Estadisticas_div" class="w-100 px-5 py-4">
      <div id="TituloEstadisticas_div">
        <h1 style="margin-bottom: 0px;">GRÁFICAS</h1>
        <h3 style="margin-top: 0px;">Consulta y creación de gráficos para estadísticos</h3>
      </div>
      <div style="display:flex">
        <div id="BusquedaEstadisticas_div" class="col-md-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos"></FiltrosDeBusqueda>            
          </div>
        </div>
        <div id="EstadisticasInformacion_div" class="col-9 padding-div-low">
          <div class="area">
            <h4>Estadísticas de la búsqueda</h4>
            <h6>Muestra y descargue las estadísticas y reportes</h6>
            <hr />
            <div id="DescargarReporte_div" class="panel-footer">
              <button class="btn btn-primary" id="descargarReporte_btn">Descargar Reporte</button>
            </div>
            <br />
            <div id="graficasEstadisticas_div">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas'
  import catalogos from '@/../static/js/catalogos'
  import highcharts from '@/../static/js/highchart'

  export default {
    components: {
      comun,
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda,
      C001Area: catalogos.PJ.C001Area,
      C002Materias: catalogos.PJ.C002Materias,
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C020Salas: catalogos.PJ.C020Salas,
      C001Jueces: catalogos.Cuentas.C001Jueces,
      C024TipoAudiencia: catalogos.PJ.C024TipoAudiencia,
      C008Delitos: catalogos.PJ.C008Delitos,
      C004TipoDocumento: catalogos.PJ.C004TipoDocumento,      
      highcharts
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.OperadoresDeSala, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
        ],
        fechaInicial: new Date().toISOString().slice(0, 10),
        fechaFinal: new Date().toISOString().slice(0, 10),
        chartOptions: {
          chart: {
            plotBackgroundColor: null,
            backgroundColor: "#DADADA",
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: 'Audiencias grabadas'
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          credits: {
            enabled: false
          },
          lang: {
            viewFullscreen: "Ver en pantalla completa",
            printChart: "Imprimir gráfica",
            downloadJPEG: "Descargar imagen JPEG",
            downloadPDF: "Descargar documento PDF",
            downloadPNG: "Descargar imagen PNG",
            downloadSVG: "Descargar imagen SVG"
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                style: {
                  color: 'black'
                }
              }
            }
          },
          series: [{
            name: 'Brands',
            colorByPoint: true,
            data: [
              {
                name: 'Juzgado de Oralidad de Aguascalientes',
                y: 61.41,
                sliced: true,
                selected: true
              }, {
                name: 'Juzgado de Oralidad de Calvillo',
                y: 11.84
              }, {
                name: 'Juzgado de Oralidad de Rincon de Ramos',
                y: 10.85
              }, {
                name: 'Segunda instancia',
                y: 4.67
              }, {
                name: 'Juzgado primero de ejecución',
                y: 4.18
              },
            ] // sample data
          }]
        }
      }
    },
    mounted() {
      this.obtenDatosDeGraficas();
    },
    methods: {
      obtenDatosDeGraficas: function() {
        
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Estadisticos/Graficas/Graficas.vue